/* tslint:disable */

/**
 */
export class ViewStran {
    key?: string;
    value?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-stran.ts